import { useLanguage } from "../../../i18n/LanguageContext";

export default function ConditionBlock({ block }) {
  const { language } = useLanguage();

  const c = block.content || {};
  const translated = block.translated_content || {};

  const getTranslation = (chineseValue, translatedValue) => {
    if (language === "zh") {
      return chineseValue || null;
    }

    if (language === "es" || language === "ru") {
      return translatedValue || null;
    }

    return null;
  };

  const nameTranslation = getTranslation(
    c.name_zh,
    translated.name
  );

  const sections = [
    [
      "Definition",
      c.definition_en,
      getTranslation(
        c.definition_zh,
        translated.definition
      ),
    ],
    [
      "Symptoms",
      c.symptoms_en,
      getTranslation(
        c.symptoms_zh,
        translated.symptoms
      ),
    ],
    [
      "Massage Contraindications",
      c.contraindications_en,
      getTranslation(
        c.contraindications_zh,
        translated.contraindications
      ),
    ],
  ];

  return (
    <div
      style={{
        padding: "20px",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        marginBottom: "14px",
        backgroundColor: "#ffffff",
      }}
    >
      {/* Canonical English condition name */}
      <h3 style={{ margin: 0 }}>
        {c.name_en}
      </h3>

      {/* Selected-language condition name */}
      {nameTranslation && (
        <div
          style={{
            color: "#6b7280",
            marginTop: "4px",
            marginBottom: "16px",
          }}
        >
          {nameTranslation}
        </div>
      )}

      {sections.map(
        ([label, english, translation]) => {
          if (!english && !translation) return null;

          return (
            <div
              key={label}
              style={{
                padding: "12px 0",
                borderTop: "1px solid #e5e7eb",
              }}
            >
              <strong>{label}</strong>

              {/* Canonical English */}
              {english && (
                <div
                  style={{
                    marginTop: "6px",
                    lineHeight: "1.6",
                  }}
                >
                  {english}
                </div>
              )}

              {/* Selected-language learning aid */}
              {translation && (
                <div
                  style={{
                    marginTop: "5px",
                    color: "#6b7280",
                    lineHeight: "1.6",
                  }}
                >
                  {translation}
                </div>
              )}
            </div>
          );
        }
      )}
    </div>
  );
}